<template>
  <BDropdown  size="sm"
              :disabled="!options || options.length === 0"
              variant="outline-secondary"
              class="dd-levels"
              toggle-class="dd-level"
              no-caret
              teleport
              strategy="fixed">
    <template #button-content>
      <span class="dd-level-text">{{ getHeaderLabel }}</span>
      <ChevronDown :size="14" class="opacity-50 flex-shrink-0" />
    </template>

    <div  v-if="options && options.length"
          class="px-4 py-0 text-muted" style="font-size: 0.7rem; line-height: 1.3;">
      {{ $t('Webportal.Matrix.PredefinedSelection') }}
    </div>

    <BDropdownItem  v-for="opt in options.filter(x => x.group === '0')"
                    :key="opt.id"
                    :disabled="opt.isEnabled === false"
                    :active="opt === modelValue"
                    @click="$emit('update:modelValue', opt)">
      <div class="d-flex align-items-center dd-height">
        <Check  v-if="opt === modelValue"
                :size="14"
                :stroke-width="3"
                class="me-2 flex-shrink-0"
                style="color: var(--custom-accent-fixed);" />
        <span v-else style="width: 14px;" class="me-2 flex-shrink-0"></span>
        <span class="font12" :class="{ 'text-muted': opt.isEnabled === false }">{{ getLabel(opt) }}</span>
      </div>
    </BDropdownItem>

    <BDropdownDivider v-if="options && options.filter(x => x.group === '1').length" />

    <div  v-if="options && options.filter(x => x.group === '1').length"
          class="px-4 py-0 text-muted" style="font-size: 0.7rem; line-height: 1.3;">
      {{ $t('Webportal.Matrix.OwnSelection') }}
    </div>

    <BDropdownItem  v-for="opt in options.filter(x => x.group === '1' && x.label !== 'ClientLocations')"
                    :key="opt.id"
                    :disabled="opt.isEnabled === false"
                    :active="opt === modelValue"
                    @click="$emit('update:modelValue', opt)">
      <div class="d-flex align-items-center dd-height">
        <Check  v-if="opt === modelValue"
                :size="14"
                :stroke-width="3"
                class="me-2 flex-shrink-0"
                style="color: var(--custom-accent-fixed);" />
        <span v-else style="width: 14px;" class="me-2 flex-shrink-0"></span>
        <span class="font12" :class="{ 'text-muted': opt.isEnabled === false }">{{ getLabel(opt) }}</span>
        <!-- ClientLocations wird hier nicht angezeigt, wir später zu Outlets -->
      </div>
    </BDropdownItem>
  </BDropdown>
</template>

<script>
import { ChevronDown, Check } from 'lucide-vue-next';

export default {
  name: 'LevelSelection',
  components: { ChevronDown, Check },
  props: {
    modelValue: { type: Object, default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Level' },
  },
  emits: ['update:modelValue'],
  computed: {
    getHeaderLabel() {
      if (!this.modelValue) return this.placeholder;
      return this.getLabel(this.modelValue);
    }
  },
  methods: {
    getLabel(opt) {
      if (opt.labelKey)
        return opt.label.replace('[[]]', this.$t(opt.labelKey));
      return opt.label;
    }
  }
}
</script>

<style lang="scss" >
.dd-levels {
  min-height: 2.25rem!important;
  min-width: 9rem!important;
}
.dd-height {
  height: 32px;
}
.dd-level {
  background: var(--custom-black-05)!important;
  border-radius: 2px!important;
  height: 2.25rem!important;
  min-width: 9rem!important;
  padding: 4px 8px!important;
  display: flex!important;
  align-items: center!important;
  justify-content: space-between!important;
  gap: 4px!important;
  font-size: var(--font-12)!important;

  &:hover {
    background: var(--custom-black-10)!important;
    border-color: var(--custom-black-20)!important;
  }

  [data-bs-theme="dark"] & {
    background: var(--custom-white-10)!important;
    &:hover {
      background: var(--custom-white-20)!important;
      border-color: var(--custom-white-20)!important;
    }
  }
}

.dd-level-text {
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.dropdown-item) {
  font-size: var(--font-12);
}
:deep(.dropdown-item.disabled) {
  color: inherit!important;
  opacity: 0.4!important;
}
</style>
